import { SkeletonOAuthBankingForm } from "@unauthenticated/oauth/components/OAuthOnboardingFlow/OAuthBankingStep/OAuthBankingInformation/OAuthBankingForm/SkeletonOAuthBankingForm";
import { OAuthStepHeader } from "@unauthenticated/oauth/components/OAuthOnboardingFlow/OAuthStepHeader/OAuthStepHeader";

import { OAuthStep } from "../../oauthStep";

import * as styles from "./OAuthBankingInformation.styles";

const SkeletonOAuthBankingInformation = () => {
  return (
    <div css={styles.main}>
      <OAuthStepHeader currentStep={OAuthStep.PAYMENT} />
      <SkeletonOAuthBankingForm />
    </div>
  );
};

export { SkeletonOAuthBankingInformation };
